import { Form, Modal } from "antd"
import React, { useState } from "react"
import { useTranslation } from "react-i18next"

import { TextInput } from "../../../../../../components/Input/TextInput.tsx"

interface SaveProjectTypeAsTemplateModalProps {
  open: boolean
  defaultName: string
  onClose: () => void
  onSubmit: (name: string) => Promise<void>
}

export function SaveProjectTypeAsTemplateModal({
  open,
  defaultName,
  onClose,
  onSubmit
}: SaveProjectTypeAsTemplateModalProps) {
  const { t } = useTranslation()
  const [form] = Form.useForm<{ name: string }>()
  const [saving, setSaving] = useState(false)

  const handleOk = async () => {
    try {
      const values = await form.validateFields()
      setSaving(true)
      try {
        await onSubmit(values.name)
        onClose()
      } finally {
        setSaving(false)
      }
    } catch {
      // Validation failed, do nothing (validation errors are shown by the form)
    }
  }

  return (
    <Modal
      open={open}
      title={t("projectTypeMenu.saveAsTemplate")}
      okText={t("projectTypeSaveAsTemplate.save", "Save")}
      onOk={() => void handleOk()}
      onCancel={onClose}
      confirmLoading={saving}
      destroyOnClose
    >
      <Form form={form} layout="vertical" initialValues={{ name: defaultName }}>
        <Form.Item
          name="name"
          label={t("projectTypeSaveAsTemplate.nameLabel", "Template name")}
          rules={[{ required: true, whitespace: true }]}
        >
          <TextInput autoFocus />
        </Form.Item>
      </Form>
    </Modal>
  )
}
